module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHElEQVQ4ja2TMUtCURiGH9MuElZki0M4KA5iS0GEQeAPCHSUcJaaBJcGB2loDdqiIRoiERwscM5BaAh0EAkcNXBzUSQsKM6tG1fPOSLUM53z3vd773e+c68jlux98gcWdKWxHYPHgo/ghlN6Zsdl32yHFzlKLZvr9bXvwpPj1YmCy9sB9Zf33/1EwIrHQShgcHrel94kyGe9pseO9gjz4lL5DhMeSdOhDEjn1EcQQ51GGXB15pU0HcqAu/JQ0vgZ4lwdbEUMSdPxv7fQbH+Y30D1eSwZBY3W2PTY0f0LI+AJ6AoP4Ad2gaWZHQA14AJ4AKbbcANxIANELdGaQQc4APaBkqJY8AYUgT0gAbxaAdfAJlBRj0nJPRABbr4AMQ83cZ2RkY8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ziranlaigao.png
// module id = uxLT
// module chunks = 106